/* eslint-disable no-unused-vars */

import { PermissionEnum } from "../types";

// 根文件权限
export enum JoyspacePermissionType {
  ReadAll = 0, // 0 拥有者
  ReadOnly = 2, // 只读
  ReadWrite = 1, // 读写
  ReadDel = 99, // 删除权限
  ReadNothing = -1 // 文档被删除或者无权限
}

// 获取文件夹/文件可编辑权限
export const getJoySpaceEditPermission = function (current: any): boolean {
  if (!current && current !== 0) {
      return false;
  }
  return (
      current === JoyspacePermissionType.ReadAll || current === JoyspacePermissionType.ReadWrite
  );
};

export const getJoySpaceReadAllPermission = function (): JoyspacePermissionType {
  return JoyspacePermissionType.ReadAll;
};

export const getJoySpaceReadWritePermission = function (): JoyspacePermissionType {
  return JoyspacePermissionType.ReadWrite;
};

export const getJoySpaceReadOnlyPermission = function (): JoyspacePermissionType {
  return JoyspacePermissionType.ReadOnly;
};

export const getJoySpaceDelPermission = function (): JoyspacePermissionType {
  return JoyspacePermissionType.ReadDel;
};

export const getJoySpaceReadNothingPermission = function (): JoyspacePermissionType {
  return JoyspacePermissionType.ReadNothing;
};

export const getJoySpaceReadFolderPermission = function (permission: any): JoyspacePermissionType {
  if (permission && permission.includes(PermissionEnum.FOLDER_PUBLIC_SET)) {
      return getJoySpaceReadAllPermission()
  } else if (permission && permission.includes(PermissionEnum.FOLDER_EDIT)) {
      return getJoySpaceReadWritePermission()
  } else {
      return getJoySpaceReadOnlyPermission()
  }
};

export const  getJoySpaceReadPagePermission = function(permission: any): JoyspacePermissionType {
  if (permission && permission.includes(PermissionEnum.PAGE_EDIT)) {
      return getJoySpaceReadWritePermission()
  } else {
      return getJoySpaceReadOnlyPermission()
  }
};